import React, { useState, useEffect } from 'react';
import Icon from '../../../components/AppIcon';

const BlockchainStatusCard = () => {
  const [status, setStatus] = useState('connected');
  const [transactionCount, setTransactionCount] = useState(1247);
  const [lastBlockTime, setLastBlockTime] = useState(new Date());
  const [networkHealth, setNetworkHealth] = useState(98.5);

  useEffect(() => {
    const interval = setInterval(() => {
      setTransactionCount(prev => prev + Math.floor(Math.random() * 3));
      setLastBlockTime(new Date());
      
      const random = Math.random();
      if (random < 0.05) {
        setStatus('processing');
        setTimeout(() => setStatus('connected'), 2000);
      }
    }, 30000);

    return () => clearInterval(interval);
  }, []);

  const getStatusConfig = () => {
    switch (status) {
      case 'connected':
        return {
          color: 'text-success',
          bgColor: 'bg-success',
          icon: 'CheckCircle',
          label: 'Connected',
          description: 'Blockchain network operational'
        };
      case 'processing':
        return {
          color: 'text-warning',
          bgColor: 'bg-warning',
          icon: 'Clock',
          label: 'Processing',
          description: 'Transaction verification in progress'
        };
      default:
        return {
          color: 'text-error',
          bgColor: 'bg-error',
          icon: 'AlertCircle',
          label: 'Error',
          description: 'Network connectivity issues'
        };
    }
  };

  const statusConfig = getStatusConfig();

  return (
    <div className="bg-card border border-border rounded-lg p-6">
      <div className="flex items-center justify-between mb-4">
        <div className="flex items-center space-x-3">
          <div className={`p-2 rounded-lg ${statusConfig?.bgColor}`}>
            <Icon name="Blocks" size={20} color="white" />
          </div>
          <div>
            <h3 className="font-semibold text-foreground">Blockchain Network</h3>
            <p className="text-sm text-muted-foreground">{statusConfig?.description}</p>
          </div>
        </div>
        <div className={`flex items-center space-x-2 px-3 py-1 rounded-full bg-muted`}>
          <div className={`w-2 h-2 rounded-full ${statusConfig?.color}`}>
            <div className="w-full h-full bg-current rounded-full animate-pulse"></div>
          </div>
          <span className="text-xs font-mono text-muted-foreground">{statusConfig?.label}</span>
        </div>
      </div>
      <div className="grid grid-cols-2 gap-4">
        <div className="space-y-1">
          <p className="text-xs text-muted-foreground uppercase tracking-wide">Transactions</p>
          <p className="text-lg font-mono font-semibold text-foreground">
            {transactionCount?.toLocaleString()}
          </p>
        </div>
        <div className="space-y-1">
          <p className="text-xs text-muted-foreground uppercase tracking-wide">Network Health</p>
          <p className="text-lg font-mono font-semibold text-foreground">
            {networkHealth}%
          </p>
        </div>
      </div>
      <div className="mt-4 pt-4 border-t border-border">
        <div className="flex items-center justify-between text-xs text-muted-foreground">
          <span>Last Block: {lastBlockTime?.toLocaleTimeString('en-GB', { hour12: false })}</span>
          <span>{Math.floor((new Date() - lastBlockTime) / 1000)}s ago</span>
        </div>
      </div>
    </div>
  );
};

export default BlockchainStatusCard;